// Print stuff
import $ from 'jquery';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import * as Site from "../js/site";
import * as Constants from "./constants";

let logoImage;
let mapImageWidth = 500, mapImageHeight = 400;
let MapView, PrintTask, PrintTemplate, PrintParameters, GetSelectedParcelAttributes;
let selectedParcelAttributes;

export const initPrint = (mapView, printTask, printTemplate, printParameters, getSelectedParcelAttributes) => {
  console.log("Print->initPrint");
  $("#main-print-button").click(function () { createMapImage(); });

  MapView = mapView;
  PrintTask = printTask;
  PrintTemplate = printTemplate;
  PrintParameters = printParameters;
  GetSelectedParcelAttributes = getSelectedParcelAttributes;

  logoImage = new Image();
  logoImage.crossOrigin = "Anonymous";
  //logoImage.src = "images/encinitas-logo-report.jpg";
  logoImage.src = "https://coe-ezoning.azurewebsites.net/images/encinitas-logo-report-sand.jpg";
}

export const createMapImage = () => {
  Site.displayMessage("#main-print", "Beginning report generation.");

  selectedParcelAttributes = GetSelectedParcelAttributes();

  Site.addToDisplayMessage("#main-print", "Generating map image...", true);

  let printTemplate = new PrintTemplate();
  printTemplate.format = "JPG";
  printTemplate.layout = "MAP_ONLY";
  printTemplate.preserveScale = false;
  printTemplate.exportOptions = {
    width: mapImageWidth,
    height: mapImageHeight,
    dpi: 96
  };

  let params = new PrintParameters();
  params.view = MapView;
  params.template = printTemplate;

  let printTask = new PrintTask(Constants.printServiceUrl);
  printTask.execute(params)
    .then(function (printResult, printError) {
      let results = printResult;
      let url = printResult.url;
      createZoningReport(printResult.url);
    })
    .catch(function (error) {
      Site.displayError("#main-print", "Zoning report generation error: " + error.message);
      console.log("Zoning report generation error: ", error.message);
    });
}

export const createZoningReport = (url) => {
  let title = $.trim($("#main-print-title-input").val());
  console.log("Creating zoning report: " + title);

  Site.addToDisplayMessage("#main-print", "Loading map image...", true);
  let mapImg = new Image();
  mapImg.crossOrigin = "Anonymous";
  mapImg.onError = function () {
    Site.displayError("#map-print", "Cannot load saved map image: " + url);
  };
  mapImg.onload = function () {
    createPDF(title, mapImg);
  };
  mapImg.src = url;
};

function createPDF(title, mapImage) {
  Site.addToDisplayMessage("#main-print", "Creating PDF...", true);
  let colorWhite = "#FFF";
  let colorTeal = "#007477";
  let colorSand = "#D7C7AF";
  let colorSandDark = "#c6af8d";
  let colorSlate = "#58595B";
  let colorStripe = "#fbf5ed";

  let padding = 3;
  let pageMarginHorizontal = 40;
  let pageMarginVertical = 30;
  let defaultLineWidth = 0.5;
  let pixelFactor = 0.75;

  let doc = new jsPDF("landscape", "pt", "letter");
  doc.setProperties({
    title: "City of Encinitas Zoning Report",
    subject: title,
    author: "HDR, Inc. (San Diego)",
    keywords: "hdr, gis, encinitas",
    creator: "eZoning Print Utility"
  });

  let pageWidth = (doc.internal.pageSize.width - pageMarginHorizontal * 2);
  doc.setFontSize(13);
  doc.setFont(undefined,"bold");
  doc.setTextColor(colorTeal);

  let rectHeight = 70;
  let footerRectHeight = 45;
  doc.setFillColor(colorSand);
  doc.rect(0, 0, doc.internal.pageSize.width, rectHeight, "F");

  let smRH = 6;
  doc.setFillColor(colorTeal);
  doc.rect(0, rectHeight, doc.internal.pageSize.width, smRH, "F");

  // Title
  let txt = "Encinitas Zoning Report";
  let textHeight = doc.internal.getFontSize() / doc.internal.scaleFactor;
  let textWidth = doc.getStringUnitWidth(txt) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  //let textOffset = (doc.internal.pageSize.width - textWidth) / 2;
  let textOffset = doc.internal.pageSize.width - pageMarginHorizontal - textWidth;
  let yPos = rectHeight - textHeight * 2.6;
  doc.text(txt, textOffset, yPos);

  txt = title;
  doc.setFontSize(11);
  doc.setTextColor(colorWhite);
  textHeight = doc.internal.getFontSize() / doc.internal.scaleFactor;
  textWidth = doc.getStringUnitWidth(txt) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  textOffset = doc.internal.pageSize.width - pageMarginHorizontal - textWidth;
  yPos += textHeight * 1.5;
  doc.text(txt, textOffset, yPos);

  // Logo
  let imgHeight = parseInt(logoImage.height * pixelFactor);
  let imgWidth = parseInt(logoImage.width * pixelFactor);
  doc.addImage({
    imageData: logoImage,
    angle: 0,
    x: pageMarginHorizontal,
    y: (rectHeight - imgHeight) / 2,
    w: imgWidth,
    h: imgHeight
  });

  doc.setFontSize(11);
  doc.setFont(undefined,"bold");
  doc.setTextColor(colorSlate);
  yPos = rectHeight + textHeight * 2;

  doc.text("APN: " + selectedParcelAttributes.parcel.APN, pageMarginHorizontal, yPos);
  txt = "Address: " + selectedParcelAttributes.parcel.SitusStreet;
  textWidth = doc.getStringUnitWidth(txt) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  textOffset = doc.internal.pageSize.width - textWidth - pageMarginHorizontal;
  doc.text(txt, textOffset, yPos);

  // Map
  let mapHeight = mapImage.height * pixelFactor;
  let mapWidth = mapImage.width * pixelFactor;
  let mapXPos = doc.internal.pageSize.width - mapWidth - pageMarginHorizontal;
  yPos += textHeight * 0.75;
  doc.addImage({
    imageData: mapImage,
    angle: 0,
    x: mapXPos,
    y: yPos,
    w: mapWidth,
    h: mapHeight
  });

  // Map container borders
  doc.setLineWidth(defaultLineWidth);
  doc.setDrawColor(colorSandDark);
  doc.rect(mapXPos, yPos, mapWidth, mapHeight);

  let spaces16 = "                ";
  let zoningColumns = [{ title: "Attribute", key: "attrName" }, { title: "Value", key: "attrValue" }, { title: "", key: "attrPad" }];
  let zoningRowData = [
    { "attrName": "Zone Code:", "attrValue": getAttributeValue("Zonecode"), "attrPad": spaces16 },
    { "attrName": "Description:", "attrValue": getAttributeValue("Description"), "attrPad": spaces16 },
    { "attrName": "Width (feet):", "attrValue": getAttributeValue("WidthFeet"), "attrPad": spaces16 },
    { "attrName": "Depth (feet):", "attrValue": getAttributeValue("DepthFeet"), "attrPad": spaces16 },
    { "attrName": "Maximum Density:", "attrValue": getAttributeValue("MaximumDensity"), "attrPad": spaces16 },
    { "attrName": "Midrange Density:", "attrValue": getAttributeValue("MidrangeDensity"), "attrPad": spaces16 },
    { "attrName": "Floor Area Ratio:", "attrValue": getAttributeValue("FloorAreaRatio"), "attrPad": spaces16 },
    { "attrName": "Front Setback:", "attrValue": getAttributeValue("FrontSetback"), "attrPad": spaces16 },
    { "attrName": "Height:", "attrValue": getAttributeValue("Height"), "attrPad": spaces16 },
    { "attrName": "Interior Side Yard Setback:", "attrValue": getAttributeValue("InteriorSideYardSetback"), "attrPad": spaces16 },
    { "attrName": "Street Side Yard Setback:", "attrValue": getAttributeValue("StreetSideYardSetback"), "attrPad": spaces16 },
    { "attrName": "Rear Yard Setback:", "attrValue": getAttributeValue("RearYardSetback"), "attrPad": spaces16 },
    { "attrName": "Lot Coverage Percent:", "attrValue": getAttributeValue("LotCoveragePercent"), "attrPad": spaces16 },
    { "attrName": "Net Lot Area Square Feet:", "attrValue": getAttributeValue("NetLotAreaSquareFeet"), "attrPad": spaces16 },
    { "attrName": "Parking:", "attrValue": getAttributeValue("Parking"), "attrPad": spaces16 },
    { "attrName": "Landscaping Percent:", "attrValue": getAttributeValue("LandscapingPercent"), "attrPad": spaces16 },
    { "attrName": "Reference:", "attrValue": getAttributeValue("Reference"), "attrPad": spaces16 }
  ];
  let attrBorderYPos = yPos;
  let tableLeft = pageMarginHorizontal;
  let tableRight = mapWidth + pageMarginHorizontal + 25;
  let zoningTableOptions = {
    startY: yPos,
    theme: "striped",
    margin: { top: pageMarginVertical, right: tableRight, bottom: pageMarginVertical, left: tableLeft },
    styles: { fontSize: 9, cellPadding: padding, textColor: colorSlate, cellWidth: "wrap", overflow: "linebreak" },
    headStyles: {
      textColor: colorWhite,
      fillColor: colorSand,
      fontSize: 10,
      fontType: "bold"
    },
    columnStyles: {
      attrValue: { cellWidth: "auto" }
    },
    bodyStyles: { minCellHeight: 15, valign: "middle" },
    alternateRowStyles: {
      fillColor: colorStripe
    },
    willDrawCell: function (cell) {
      // if (cell.column.index === 0) {
      //   doc.setFontType("bold");
      //   return false;
      // }
    },
    didDrawCell: function (data) {
      // Colspan
      // if (data.row.index === 1) {
      //   doc.setLineWidth(defaultLineWidth * 2);
      //   doc.setDrawColor(0, 255, 0);
      //   yPos = data.row.y;
      //   doc.line(data.settings.margin.left, yPos, data.table.width, yPos);
      // }
    }
  }
  doc.autoTable(zoningColumns, zoningRowData, zoningTableOptions);

  // Attribute container borders
  let attrHeight = mapHeight;
  let attrWidth = mapWidth - pageMarginHorizontal + 2 - 25;
  doc.setLineWidth(defaultLineWidth);
  doc.setDrawColor(colorSandDark);
  doc.rect(pageMarginHorizontal, attrBorderYPos, attrWidth, attrHeight);

  yPos += mapHeight + textHeight * 1.5;
  doc.setFontSize(9);
  doc.setFont(undefined,"bold");
  doc.setTextColor(colorSlate);
  doc.text("Footnote:", pageMarginHorizontal, yPos);

  txt = getAttributeValue("Footnote");
  if (txt !== "") {
    yPos += textHeight * 1.25;
    doc.setFont(undefined,"normal");
    let splitTxt = doc.splitTextToSize(txt, pageWidth);
    doc.text(splitTxt, pageMarginHorizontal, yPos);
  }

  // Add zone header
  doc.setFontSize(10);
  doc.setFont(undefined,"bold");
  doc.setTextColor(colorWhite);
  txt = "Overlay Zones";
  textHeight = doc.internal.getFontSize() / doc.internal.scaleFactor;
  rectHeight = textHeight * 1.5;
  yPos = doc.internal.pageSize.height - footerRectHeight - smRH - 75;
  doc.setFillColor(colorSand);
  doc.rect(pageMarginHorizontal, yPos, pageWidth, rectHeight, "F");

  yPos += doc.internal.getFontSize() / doc.internal.scaleFactor;
  textWidth = doc.getStringUnitWidth(txt) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  textOffset = (doc.internal.pageSize.width - textWidth - pageMarginHorizontal) / 2;
  doc.text(txt, textOffset, yPos);

  let groupSize = 3
  let overlayZoneRowData1 = [];
  let overlayZoneRowData2 = [];
  let overlayZoneRowData3 = [];
  let overlayZoneRowData4 = [];
  let zones = selectedParcelAttributes.overlayZones;
  for (let idx = 0; idx < groupSize; idx++) {
    let groupIdx = idx;
    overlayZoneRowData1.push({ "attrName": zones[groupIdx].name + ":", "attrValue": zones[groupIdx].inZone });
    groupIdx += groupSize;
    overlayZoneRowData2.push({ "attrName": zones[groupIdx].name + ":", "attrValue": zones[groupIdx].inZone });
    groupIdx += groupSize;
    overlayZoneRowData3.push({ "attrName": zones[groupIdx].name + ":", "attrValue": zones[groupIdx].inZone });
    groupIdx += groupSize;
    if (groupIdx < zones.length) overlayZoneRowData4.push({ "attrName": zones[groupIdx].name + ":", "attrValue": zones[groupIdx].inZone });
  }

  let groupWidth = (doc.internal.pageSize.width - pageMarginHorizontal * 2) / 4;
  tableLeft = pageMarginHorizontal;
  tableRight = doc.internal.pageSize.width - pageMarginHorizontal - 130;
  yPos += textHeight;
  let overlayZoneTableOptions = {
    startY: yPos,
    theme: "plain",
    margin: { top: pageMarginVertical, right: tableRight, bottom: pageMarginVertical, left: tableLeft },
    styles: { fontSize: 9, cellPadding: padding, textColor: colorSlate, cellWidth: "wrap", overflow: "linebreak" },
    showHead: "never",
    columnStyles: {
      attrName: { cellWidth: "auto" },
      attrValue: { cellWidth: 20, halign: "right" }
    },
    bodyStyles: { minCellHeight: 15, valign: "middle" },
    body: overlayZoneRowData1
  }
  doc.autoTable(overlayZoneTableOptions);

  let buffer = -10;
  tableLeft += groupWidth + buffer;
  tableRight -= groupWidth + buffer;
  overlayZoneTableOptions.margin.left = tableLeft;
  overlayZoneTableOptions.margin.right = tableRight;
  overlayZoneTableOptions.body = overlayZoneRowData2;
  doc.autoTable(overlayZoneTableOptions);

  tableLeft += groupWidth + buffer;
  tableRight -= groupWidth + buffer + 45;
  overlayZoneTableOptions.margin.left = tableLeft;
  overlayZoneTableOptions.margin.right = tableRight;
  overlayZoneTableOptions.body = overlayZoneRowData3;
  doc.autoTable(overlayZoneTableOptions);

  buffer = 25;
  tableLeft += groupWidth + buffer;
  tableRight -= groupWidth + buffer;
  overlayZoneTableOptions.margin.left = tableLeft;
  overlayZoneTableOptions.margin.right = tableRight;
  overlayZoneTableOptions.body = overlayZoneRowData4;
  doc.autoTable(overlayZoneTableOptions);

  // Add footer colors
  yPos = doc.internal.pageSize.height - footerRectHeight - smRH;
  doc.setFillColor(colorTeal);
  doc.rect(0, yPos, doc.internal.pageSize.width, smRH, "F");

  yPos += smRH;
  doc.setFillColor(colorSand);
  doc.rect(0, yPos, doc.internal.pageSize.width, footerRectHeight, "F");

  let date = new Date();
  let wId = date.getMinutes() + date.getSeconds();
  let hours = date.getHours();
  let ampm = hours < 12 ? "AM" : "PM";
  if (hours === 0) {
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
  }
  let mins = date.getMinutes();
  if (mins < 10) mins = "0" + mins;
  //let reportCreated = `Report created: ${(date.getMonth() + 1)}/${date.getDate()}/${date.getFullYear()} ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
  let reportCreated = "report created: " + (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear() + " " + date.getHours() + ":" + mins + " " + ampm;

  doc.setFontSize(10);
  doc.setTextColor(colorWhite);
  textHeight = doc.internal.getFontSize() / doc.internal.scaleFactor;
  yPos += textHeight * 2.5;
  doc.text(reportCreated, pageMarginHorizontal, yPos);

  Site.addToDisplayMessage("#main-print", "PDF creation complete.", true);

  let pdfName = "ZoningReport.pdf";
  // Test if browser doesn't support dataUI output (IE)
  if (!Site.iFrameDataUriTest('data:application/pdf;base64,')) {
    Site.addToDisplayMessage("#main-print", "</br>Select report viewing options at the bottom of the browser window.", true);
    doc.save(pdfName);
  } else {
    //doc.output('dataurlnewwindow');
    // Chrome stopped supporting top level data url's. This is the workaround.
    txt = "</br>**Note: If the report did not open in a new browser window or tab, check to see if popups/redirects are being blocked.";
    Site.addToDisplayMessage("#main-print", txt, true);
    let datauri = doc.output("datauristring");
    let urlWithName = datauri.replace("data:application/pdf;", "data:application/pdf;name=" + pdfName + ";");
    let html = '<html>' +
      '<style>html, body {padding: 0;margin: 0;} iframe {width:100%;height:100%;border: 0;}</style>' +
      '<body>' +
      '<iframe type="application/pdf" src="' + urlWithName + '"></iframe>' +
      '</body></html>';
    let w = window.open("about:blank", pdfName + wId);
    w.document.write(html);
    w.document.close();
  }
}

function getAttributeValue(attr) {
  let val = "";
  if (selectedParcelAttributes.zoning) {
    val = selectedParcelAttributes.zoning[attr];
    if (val === "Null") val = "";
  }
  return val;
}